class Answers {
  constructor() {}
  getResultId(_answers) {
    //回答のIDの昇順に配列を並び変える
    _answers.sort(function(a, b) {
      return a.id - b.id;
    });
    //回答のラベルの値のみ抜き出した配列を作成する
    const answers = _answers.map(function(element) {
      return element.answer.label;
    });
    console.log(answers);
    //質問1 あなたの性別は？
    if (answers[0] === "女性") {
      //質問2 あなたの年代は？
      if (answers[1] === "20代" || answers[1] === "30代") {
        //質問3 ご結婚は？
        if (answers[2] === "してる") {
          //質問4 お子さまは？
          if (answers[3] === "いる") {
            return 1;
          } else if (answers[3] === "いない") {
            //質問5 お子さまの希望は
            if (answers[4] === "ある") {
              return 1;
            } else if (answers[4] === "ない") {
              return 2;
            }
          }
        } else if (answers[2] === "してない") {
          //質問4 お子さまは？
          if (answers[3] === "いる") {
            return 3;
          } else if (answers[3] === "いない") {
            //質問5 お子さまの希望は
            if (answers[4] === "ある") {
              return 1;
            } else if (answers[4] === "ない") {
              return 2;
            }
          }
        }
      } else if (answers[1] === "40代" || answers[1] === "50代～") {
        //質問3 ご結婚は？
        if (answers[2] === "してる") {
          //質問4 お子さまは？
          if (answers[3] === "いる") {
            return 4;
          } else if (answers[3] === "いない") {
            //質問5 お子さまの希望は
            if (answers[4] === "ある") {
              return 4;
            } else if (answers[4] === "ない") {
              return 5;
            }
          }
        } else if (answers[2] === "してない") {
          //質問4 お子さまは？
          if (answers[3] === "いる") {
            return 6;
          } else if (answers[3] === "いない") {
            //質問5 お子さまの希望は
            if (answers[4] === "ある") {
              return 4;
            } else if (answers[4] === "ない") {
              return 5;
            }
          }
        }
      }
    } else if (answers[0] === "男性") {
      //質問2 あなたの年代は？
      if (answers[1] === "20代" || answers[1] === "30代") {
        //質問3 ご結婚は？
        if (answers[2] === "してる") {
          //質問4 お子さまは？
          if (answers[3] === "いる") {
            return 7;
          } else if (answers[3] === "いない") {
            //質問5 お子さまの希望は
            if (answers[4] === "ある") {
              return 7;
            } else if (answers[4] === "ない") {
              return 8;
            }
          }
        } else if (answers[2] === "してない") {
          //質問4 お子さまは？
          if (answers[3] === "いる") {
            return 7;
          } else if (answers[3] === "いない") {
            //質問5 お子さまの希望は
            if (answers[4] === "ある") {
              return 7;
            } else if (answers[4] === "ない") {
              return 8;
            }
          }
        }
      } else if (answers[1] === "40代" || answers[1] === "50代～") {
        //質問3 ご結婚は？
        if (answers[2] === "してる") {
          //質問4 お子さまは？
          if (answers[3] === "いる") {
            return 9;
          } else if (answers[3] === "いない") {
            //質問5 お子さまの希望は
            if (answers[4] === "ある") {
              return 9;
            } else if (answers[4] === "ない") {
              return 10;
            }
          }
        } else if (answers[2] === "してない") {
          //質問4 お子さまは？
          if (answers[3] === "いる") {
            return 9;
          } else if (answers[3] === "いない") {
            //質問5 お子さまの希望は
            if (answers[4] === "ある") {
              return 9;
            } else if (answers[4] === "ない") {
              return 10;
            }
          }
        }
      }
    }
    return false;
  }
}

export default new Answers();
